export default {
    client: "Client",
    country: "Country",
    in_case_of_doubts_about_the_operation_of_the_platform_points_or_any_information_not_related_to_the_content_of_the_courses_fill_out_the_form_to_contact_our_support_team_our_response_time_is_7_working_days: "In case of doubts about the operation of the platform, points, or any information not related to the content of the courses, fill out the form to contact our support team.",
    subject: "Subject"
}